import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction, EventAttributes } from '~/app/tracking/feld-m-types';

export type StockCarClickEventParams = {
	eventAction: EventAction;
	eventName: string;
	elementName: string;
	label: string;
	pos?: string;
	targetURL?: string;
	value?: string;
	relatedFilters?: EventAttributes['relatedFilters'];
	relatedProducts?: EventAttributes['relatedProducts'];
};

export class StockCarClickEvent extends BaseEvent {
	constructor({
		eventAction,
		eventName,
		elementName,
		label,
		pos = '',
		targetURL = '',
		value = '',
		relatedFilters,
		relatedProducts,
	}: StockCarClickEventParams) {
		super({
			eventInfo: {
				eventAction,
				eventName,
			},
			attributes: {
				componentName: 'configurator-stock-car-matching',
				label,
				targetURL,
				elementName,
				pos,
				value,
				...(relatedFilters && { relatedFilters }),
				...(relatedProducts && { relatedProducts }),
			},
		});
	}
}
